import Vue from 'vue'
import { CONST } from '@/utils/constants'

export default {
  userId: (state) => state.userId,
  abilities: (state) => state.abilities,
  startPage: (state) => state.startPage,
  continuationRoute: (state) => state.continuationRoute,
  loginRedirect: (state) => state.loginRedirect,
  theme: (state) => state.theme,
  errors: (state) => state.errors,
  authenticating: (state) => state.authenticating,
  reports: (state) => state.reports,
  retrievingCurrentUser: (state) => state.retrievingCurrentUser,
  language: (state) => {
    const cookie = Vue.cookie.get(CONST.Cookies.i18n.Language) || Vue.cookie.get(CONST.Cookies.i18n.Locale)
    const user = state.language || state.locale
    const browser = navigator.language
    const fallback = CONST.Defaults.Language
    return user || cookie || browser || fallback
  },
  canNameWorkspace: (state) => {
    return state.abilities.CanNameWorkspace
  }
}
